import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ROUTER
import { useNavigate } from "react-router-dom";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateRoleRefreshTable } from "../../../redux/roles/roleSlice";
// COMPONENTS
import ButtonRefreshTable from "../../components/buttons/ButtonRefreshTable";
import ButtonCreateItem from "../../components/buttons/ButtonCreateItem";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function RolesHeader() {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleOpenModalCreateNewRole = () => {
    navigate("/organization-management/roles/create");
  };

  const onClickReloadPage = () => {
    dispatch(updateRoleRefreshTable(true));
    setTimeout(() => {
      dispatch(updateRoleRefreshTable(false));
    }, 1000);
  };

  return (
    <div className="generalStyles__pageHeader">
      {hasPermission(Permission.RolesCreate, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonCreateItem
            onClick={handleOpenModalCreateNewRole}
            label={t("organizationManagement.createNewRole")}
          />
        </div>
      )}
      {hasPermission(Permission.RolesView, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonRefreshTable
            onClick={onClickReloadPage}
            label={t("organizationManagement.refreshTable")}
          />
        </div>
      )}
    </div>
  );
}

export default RolesHeader;
